module.exports = __webpack_public_path__ + "assets/img/gar8-4.73c89389.jpg";